var $ = require('jquery');

$(function() {
	const link_nodes = document.querySelectorAll('a[href^="http"]');
	[...link_nodes]
		.filter( e => e.hostname && e.hostname !== location.hostname )
		.forEach( e => e.setAttribute('target', '_blank') )
	;

});

